<template>
    <div>
        <p>
            Mode
            <b-select v-model="mode" :options="[
                { text: 'Fichiers vers csv', value: 'fichiers vers csv' },
                { text: 'Csv vers fichiers', value: 'csv vers fichiers' },
                { text: 'Csv', value: 'csv' }
            ]" />
        </p>

        <!-- mode "csv" : le worker sérialise directement les données courantes en csv, -->
        <!-- aucune colonne de mapping n'est utilisée -->
        <p v-if="mode === 'csv'" class="text-muted">
            Ce mode génère un fichier csv à partir de toutes les colonnes des données actuelles, sans mapping de colonnes.
        </p>

        <template v-else>
            <p>
                Nom de la colonne des noms de fichiers
                <b-input :list="'col_name' + id" v-model="column_name" placeholder="name" />
                <datalist :id="'col_name' + id">
                    <option v-for="(c, ci) in columns_data" :key="'cn' + ci">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Nom de la colonne des urls
                <b-input :list="'col_url' + id" v-model="column_url" placeholder="url" />
                <datalist :id="'col_url' + id">
                    <option v-for="(c, ci) in columns_data" :key="'cu' + ci">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Nom de la colonne de contenu du fichier
                <b-input :list="'col_content' + id" v-model="column_content" />
                <datalist :id="'col_content' + id">
                    <option v-for="(c, ci) in columns_data" :key="'cc' + ci">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Nom de la colonne des détails du fichier
                <b-input :list="'col_details' + id" v-model="column_details" />
                <datalist :id="'col_details' + id">
                    <option v-for="(c, ci) in columns_data" :key="'cd' + ci">{{ c }}</option>
                </datalist>
            </p>

            <!-- column_type n'est utilisé que par le worker en mode "csv vers fichiers" -->
            <p v-if="mode === 'csv vers fichiers'">
                Nom de la colonne des types
                <b-input :list="'col_type' + id" v-model="column_type" />
                <datalist :id="'col_type' + id">
                    <option v-for="(c, ci) in columns_data" :key="'ct' + ci">{{ c }}</option>
                </datalist>
            </p>
        </template>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "file_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                mode: "fichiers vers csv",
                column_name: "name",
                column_url: "url",
                column_content: "",
                column_details: "",
                column_type: ""
            };
        },
        methods: {
            save() {
                return {
                    mode: this.mode,
                    column_name: this.column_name,
                    column_url: this.column_url,
                    column_content: this.column_content,
                    column_details: this.column_details,
                    column_type: this.column_type
                };
            },
            async load(data) {
                if (!data) return;

                this.mode = data.mode || "fichiers vers csv";
                this.column_name = data.column_name || "name";
                this.column_url = data.column_url || "url";
                this.column_content = data.column_content || "";
                this.column_details = data.column_details || "";
                this.column_type = data.column_type || "";
            }
        }
    };
</script>

<style scoped>
</style>
